import React from 'react';

function UsersServerPage() {
    return <div>Users Server Page</div>;
}

export default UsersServerPage;
